import React from 'react';
import { Field } from 'react-final-form';
import CustomInputField from '../../../../components/form/CustomInputField';
import CustomSelect from '../../../../components/form/CustomSelect';
import { useDict } from '../../../../contexts/LanguageContext';

const UnemployedRetiredSelected = ({
    submitted,
    jobCategory,
    annualIncome,
    netWorth,
}) => {
    const dict = useDict();

    return (
        <span style={{ width: '100%' }}>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.previousCompanyName}
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap" data-private>
                        <Field name="company_name">
                            {({ input, meta }) => (
                                <CustomInputField
                                    input={input}
                                    meta={meta}
                                    submitted={submitted}
                                    style={{
                                        height: '40px',
                                        borderRadius: '25px',
                                    }}
                                    type="text"
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.previousJobCategory}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }} />
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap">
                        <Field name="job_category_id">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={jobCategory}
                                    placeholder={dict.selectJobCategory}
                                    submitted={submitted}
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.previousAnnualEmploymentIncome}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }} />
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap" data-private>
                        <Field name="annual_income">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={annualIncome}
                                    placeholder={dict.selectAnnualEmploymentIncome}
                                    submitted={submitted}
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
            <div className="form__form-group">
                <span className="form__form-group-label">
                    {dict.netWorth}:
                    <span style={{ color: '#FF3333', fontWeight: 'bold' }}>
                        *
                    </span>
                </span>
                <div className="form__form-group-field">
                    <div className="form__form-group-input-wrap" data-private>
                        <Field name="networth_id">
                            {({ input, meta }) => (
                                <CustomSelect
                                    input={input}
                                    meta={meta}
                                    options={netWorth}
                                    placeholder={dict.selectNetWorth}
                                    submitted={submitted}
                                />
                            )}
                        </Field>
                    </div>
                </div>
            </div>
        </span>
    );
};

UnemployedRetiredSelected.defaultProps = {
    submitted: false,
    jobCategory: [],
    annualIncome: [],
    netWorth: [],
};

export default UnemployedRetiredSelected;
